import OriginalCarImageIcon from "@/assets/illustrations/OriginalCarImageIcon.svg";
import { EditDialog } from "@/components/custom/EditDialog";

type CarAllocationCardProps = {
  details: {
    vrn: string | null | undefined;
    hubName: string | null | undefined;
    soc: number | null | undefined;
    odo: number | null | undefined;
  };
  odo: number;
  setOdo: (odo: number) => void;
  soc: number;
  setSoc: (soc: number) => void;
};

const CarAllocationCard = ({
  details,
  odo,
  setOdo,
  soc,
  setSoc,
}: CarAllocationCardProps) => {
  const handleOdoSave = (newOdo: number) => {
    setOdo(newOdo);
  };

  const handleSocSave = (newSoc: number) => {
    setSoc(newSoc);
  };

  return (
    <div className="w-5/6 shadow-[0px_2px_0px_#3ebec8] rounded-[30px] box-border border-2 border-solid border-primary flex justify-center items-center p-4 bg-white">
      <div className="flex flex-col gap-2 items-center">
        <h1>Allocation Details</h1>
        <h3 className="text-primary">{details.hubName ?? "—"}</h3>
        <img src={OriginalCarImageIcon} className="w-60" />
        <h1>{details.vrn==="" ? "-" : details.vrn}</h1>
        <div className="grid grid-cols-2 gap-8 mt-4">
          <div className="flex flex-col items-center">
            <div className="flex flex-row items-center">
              <h3>Odometer</h3>
              <EditDialog
                title="Edit Odometer Reading"
                description="Update the odometer reading below."
                initialValue={odo}
                onSave={handleOdoSave}
                label="Odometer"
                unit="KM"
              />
            </div>
            <h5 className="text-primary">
              {odo != null ? `${odo.toFixed(2)} KM` : "—"}
            </h5>
          </div>
          <div className="flex flex-col items-center">
            <div className="flex flex-row items-center">
              <h3>SOC</h3>
              <EditDialog
                title="Edit SOC Reading"
                description="Update the SOC reading below."
                initialValue={soc}
                onSave={handleSocSave}
                label="SOC"
                unit="%"
                type="soc"
              />
            </div>
            <h5 className="text-primary">{soc != null ? `${soc}%` : "—"}</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarAllocationCard;
